/* @flow */
export default function errorLogger(message: string) {
  return (error?: Error | ?string) => {
    const { Rollbar } = window || {};
    if (Rollbar) {
      Rollbar.error(message, error);
    } else {
      console.warn(error);
      console.error(message);
    }
  };
}
